import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { toast } from 'react-toastify'
import SectionTitle from '../SectionTitle'
import AuthModal from '../AuthModal'
import LevelTestModal from '../LevelTestModal'
import assessmentService from '../../services/assessmentService'
import arabicBg from '../../images/arabic-bg-dark.svg'
import girlWithBooksImg from '../../images/children/girl_with_books.png'
import airplaneImg from '../../images/children/airplane.png'
import paperPlaneImg from '../../images/children/paper_plane.png'
import anasBotImg from '../../images/children/anas_bot.png'
import { useTranslation } from 'react-i18next'
import './style.css'

const LevelTest = (props) => {
    const { t } = useTranslation();
    const { isAuthenticated, user } = useAuth();
    const navigate = useNavigate();
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [showRestrictionModal, setShowRestrictionModal] = useState(false);
    const [existingResult, setExistingResult] = useState(null);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const handleLevelTestClick = async (e) => {
        e.preventDefault();
        ClickHandler();

        // Allow guests to proceed directly to test
        if (!isAuthenticated) {
            navigate('/level-test');
            return;
        }

        // For authenticated users, check if they have already taken the test
        try {
            console.log('[Homepage LevelTest] Checking test history for user:', user?.email);
            const history = await assessmentService.getTestHistory();
            console.log('[Homepage LevelTest] Test history received:', history);

            // Handle both response formats: array or object with tests property
            const tests = Array.isArray(history) ? history : (history?.tests || []);
            console.log('[Homepage LevelTest] Parsed tests array:', tests);

            if (tests && tests.length > 0) {
                // User has already taken the test - show restriction modal
                const mostRecentTest = tests[0];
                console.log('[Homepage LevelTest] Found existing test result:', mostRecentTest);
                setExistingResult(mostRecentTest);
                setShowRestrictionModal(true);
            } else {
                // No existing result - allow navigation to test
                console.log('[Homepage LevelTest] No existing test results - allowing navigation');
                navigate('/level-test');
            }
        } catch (error) {
            // If error checking history, allow user to proceed
            console.error('[Homepage LevelTest] Error checking test history:', error);
            navigate('/level-test');
        }
    };

    return (
        <section id="level-test" className={`wpo-level-test-section section-padding ${props.lClass || ''}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div
                            className="wpo-level-test-wrapper"
                            style={{
                                position: 'relative'
                            }}
                        >
                            {/* Arabic Background */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundImage: `url(${arabicBg})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 0.05,
                                    zIndex: 0,
                                    borderRadius: '20px'
                                }}
                            />
                            <div className="wpo-level-test-content" style={{ position: 'relative', zIndex: 1 }}>
                                <SectionTitle
                                    subTitle={t('levelTest.onlineLevelTest')}
                                    MainTitle={t('levelTest.evaluateYourLevel')}
                                    vTitle={t('levelTest.levelTestTransparent')}
                                />

                                <div className="wpo-level-test-description">
                                    <p>
                                        {t('levelTest.testDescription1')}
                                    </p>
                                    <p>
                                        {t('levelTest.testDescription2')}
                                    </p>
                                </div>

                                <div className="wpo-level-test-actions">
                                    <a
                                        href="#"
                                        onClick={handleLevelTestClick}
                                        className="theme-btn"
                                    >
                                        {t('levelTest.testYourLevelNow')}
                                    </a>
                                </div>

                                <div className="wpo-level-test-footer">
                                    <span className="wpo-level-test-contact-text">
                                        {t('levelTest.contactUsToKnow')}
                                    </span>
                                    <Link onClick={ClickHandler} className="theme-btn-s2" to="/contact">
                                        {t('levelTest.contactUs')}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Girl with books positioned at bottom left corner - outside container */}
                <div className="level-test-girl-books-container">
                    <img src={girlWithBooksImg} alt="Girl with books" className="level-test-girl-books-img" loading="lazy" decoding="async" />
                </div>

                {/* Airplane positioned at upper right corner - outside container */}
                <div className="level-test-airplane-container">
                    <img src={airplaneImg} alt="Airplane" className="level-test-airplane-img" loading="lazy" decoding="async" />
                </div>

                {/* Paper plane positioned at top left corner - same as features but 50% smaller */}
                <div className="level-test-paper-plane-container">
                    <img src={paperPlaneImg} alt="Paper plane" className="level-test-paper-plane-img" loading="lazy" decoding="async" />
                </div>

                {/* Anas Bot positioned at bottom right corner */}
                <div className="level-test-anas-bot-container">
                    <img src={anasBotImg} alt="Anas Bot" className="level-test-anas-bot-img" loading="lazy" decoding="async" />
                </div>
            </div>

            {/* Authentication Modal */}
            <AuthModal
                isOpen={showAuthModal}
                onClose={() => setShowAuthModal(false)}
                title="Account Required"
                message="To test your Arabic language level you need to set up your account first"
                type="level-test"
                redirectState={{ from: '/level-test', action: 'level-test' }}
            />

            {/* Level Test Restriction Modal */}
            <LevelTestModal
                isOpen={showRestrictionModal}
                onClose={() => setShowRestrictionModal(false)}
                existingResult={existingResult}
            />
        </section>
    )
}

export default LevelTest
